module.exports = __webpack_public_path__ + "static/media/iconSettings.6b92f73b.svg";